import React, { useState, useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";

const Edit = ({ productData }) => {
  const { dbCategories, loadProducts } = useContext(CartContext);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([null, null, null, null]);
  const [previews, setPreviews] = useState(["", "", "", ""]);
  const [formData, setFormData] = useState({ ...productData });

  const handleShow = () => {
    let current = ["", "", "", ""];
    if (productData.imagenes) {
      try {
        let data =
          typeof productData.imagenes === "string"
            ? JSON.parse(productData.imagenes)
            : productData.imagenes;
        if (Array.isArray(data)) {
          data.forEach((item, i) => {
            if (i < 4 && item) {
              let fileName = typeof item === "object" ? item.name : item;
              fileName = String(fileName)
                .replace(/[\[\]"']/g, "")
                .trim();
              if (fileName && fileName !== "null") {
                current[i] = `https://optimarketok.com.ar/imagenes/${fileName}`;
              }
            }
          });
        }
      } catch (e) {
        let raw = String(productData.imagenes).replace(/[\[\]"']/g, "");
        const lista = raw.split(",").map((img) => img.trim());
        lista.forEach((img, i) => {
          if (i < 4 && img && img !== "null")
            current[i] = `https://optimarketok.com.ar/imagenes/${img}`;
        });
      }
    }
    setFormData({ ...productData });
    setPreviews(current);
    setImages([null, null, null, null]);
    setShow(true);
  };

  const handleImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);
      const newPreviews = [...previews];
      newPreviews[index] = URL.createObjectURL(file);
      setPreviews(newPreviews);
    }
  };

  const removeImage = (index) => {
    const newPreviews = [...previews];
    newPreviews[index] = "";
    setPreviews(newPreviews);
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();

    // Pasamos todos los campos del formulario al FormData
    Object.keys(formData).forEach((key) =>
      data.append(key, formData[key] || ""),
    );

    // Lógica de imágenes (Nuevas o Existentes)
    previews.forEach((p, i) => {
      if (images[i]) {
        // Si hay un archivo nuevo, lo adjuntamos
        data.append(`image_${i}`, images[i]);
      } else if (p && !p.startsWith("blob:")) {
        // Si no es un blob de preview, es una imagen que ya estaba en el servidor
        const fileName = p.split("/").pop();
        data.append(`existing_image_${i}`, fileName);
      }
    });

    try {
      const resp = await fetch(
        "https://optimarketok.com.ar/api/update_product.php",
        {
          method: "POST",
          body: data,
          // --- AGREGAMOS ESTO PARA LA SESIÓN ---
          credentials: "include",
        },
      );

      const res = await resp.json();

      if (res.success) {
        Swal.fire("¡Listo!", "Producto actualizado", "success");
        await loadProducts(); // Cargamos la lista actualizada
        setShow(false);
      } else {
        // Manejo de error por falta de permisos o error de DB
        Swal.fire("Error", res.message || "No se pudo actualizar", "error");
      }
    } catch (err) {
      console.error("Error en el update:", err);
      Swal.fire("Error", "No se pudo conectar con el servidor", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-link text-primary p-0" onClick={handleShow}>
        <i className="bi bi-pencil-square fs-5"></i>
      </button>

      <Modal show={show} onHide={() => setShow(false)} size="lg">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title className="h5">Editar Producto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* IMÁGENES */}
            <div className="row g-2 mb-4">
              {[0, 1, 2, 3].map((i) => (
                <div key={i} className="col-3 text-center position-relative">
                  <div
                    onClick={() =>
                      document.getElementById(`edit-img-${i}`).click()
                    }
                    className="border rounded d-flex align-items-center justify-content-center bg-light shadow-sm"
                    style={{
                      height: "100px",
                      cursor: "pointer",
                      overflow: "hidden",
                    }}
                  >
                    {previews[i] ? (
                      <img
                        src={previews[i]}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        alt=""
                      />
                    ) : (
                      <i className="bi bi-camera fs-2 text-muted"></i>
                    )}
                  </div>
                  {previews[i] && (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm position-absolute border-white"
                      style={{
                        top: "-5px",
                        right: "5px",
                        borderRadius: "50%",
                        zIndex: 10,
                        padding: "2px 6px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeImage(i);
                      }}
                    >
                      <i className="bi bi-trash-fill small"></i>
                    </button>
                  )}
                  <input
                    type="file"
                    id={`edit-img-${i}`}
                    hidden
                    accept="image/*"
                    onChange={(e) => handleImageChange(i, e)}
                  />
                </div>
              ))}
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <Form.Label className="small fw-bold">Estado</Form.Label>
                <Form.Select
                  value={formData.estado || "activo"}
                  className={
                    formData.estado === "pausado"
                      ? "text-danger fw-bold"
                      : "text-success fw-bold"
                  }
                  onChange={(e) =>
                    setFormData({ ...formData, estado: e.target.value })
                  }
                >
                  <option value="activo">ACTIVO</option>
                  <option value="pausado">PAUSADO</option>
                </Form.Select>
              </div>
              <div className="col-md-6">
                <Form.Label className="small fw-bold">Categoría</Form.Label>
                <Form.Select
                  required
                  value={formData.categoria}
                  onChange={(e) =>
                    setFormData({ ...formData, categoria: e.target.value })
                  }
                >
                  <option value="">Seleccionar...</option>
                  {dbCategories.map((cat) => (
                    <option key={cat.id} value={cat.nombre}>
                      {cat.nombre}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold">Título</Form.Label>
              <Form.Control
                value={formData.titulo}
                onChange={(e) =>
                  setFormData({ ...formData, titulo: e.target.value })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold">Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.descripcion || ""}
                onChange={(e) =>
                  setFormData({ ...formData, descripcion: e.target.value })
                }
              />
            </Form.Group>

            <div className="row mb-3">
              <div className="col-6">
                <Form.Label className="small fw-bold">Precio ($)</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.precio}
                  onChange={(e) =>
                    setFormData({ ...formData, precio: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <Form.Label className="small fw-bold">Stock</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.stock}
                  onChange={(e) =>
                    setFormData({ ...formData, stock: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="row g-2 p-3 border rounded bg-light">
              <div className="col-12">
                <small className="fw-bold text-muted uppercase">
                  Medidas (mm)
                </small>
              </div>
              <div className="col-4">
                <Form.Label className="small mb-0">Alto</Form.Label>
                <Form.Control
                  value={formData.alto || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, alto: e.target.value })
                  }
                />
              </div>
              <div className="col-4">
                <Form.Label className="small mb-0">Ancho</Form.Label>
                <Form.Control
                  value={formData.ancho || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, ancho: e.target.value })
                  }
                />
              </div>
              <div className="col-4">
                <Form.Label className="small mb-0">Patilla</Form.Label>
                <Form.Control
                  value={formData.patilla || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, patilla: e.target.value })
                  }
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShow(false)}>
              Cerrar
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="px-5"
            >
              {loading ? "GUARDANDO..." : "ACTUALIZAR"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Edit;
